import _export from '../internals/export.js';
import anObject$1 from '../internals/an-object.js';
import aPossiblePrototype$1 from '../internals/a-possible-prototype.js';
import objectSetPrototypeOf$1 from '../internals/object-set-prototype-of.js';

var $ = _export;
var anObject = anObject$1;
var aPossiblePrototype = aPossiblePrototype$1;
var objectSetPrototypeOf = objectSetPrototypeOf$1; // `Reflect.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-reflect.setprototypeof

if (objectSetPrototypeOf) $({
  target: 'Reflect',
  stat: true
}, {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    anObject(target);
    aPossiblePrototype(proto);

    try {
      objectSetPrototypeOf(target, proto);
      return true;
    } catch (error) {
      return false;
    }
  }
});
